import styled from 'styled-components';

/*
 * Styles.
 */

export const AtomLine = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;

  & > *:not(:first-child) {
    margin-left: 5px;
  }

  span {
    white-space: nowrap;
  }
`;
